import * as moment from 'moment';
import {Constants} from '../constants';
import {LocaleHandler} from './locale-handler';
import { Injectable } from '@angular/core';

@Injectable()
export class DateHandler {
    /**
     * Available date formats
     * @var {object}
     */
    private _formats: object = {
        'pretty': Constants.DATE_FORMAT_PRETTY,
        'raw': Constants.DATE_FORMAT_RAW,
        'analytics': Constants.DATE_FORMAT_ANALYTICS,
        'monthAvailAnalytics': Constants.DATE_FORMAT_MONTH_AVAIL_ANALYTICS
    };

    constructor(
        private _localeHandler: LocaleHandler
    ) {
        moment.locale(this._localeHandler.getCurrentPreferredLanguage());
    }

    /**
     * Formats a moment date on a readable string
     * @param date
     * @param type
     *
     * @returns {string}
     */
    public formatDate(type: ('pretty'|'raw'|'analytics'|'monthAvailAnalytics'), date?: any): string {
        date = this.convertDateToMomentObject(!!date ? date : moment());

        return date.format(this._formats[type]);
    }

    /**
     * Converts a date to a moment object if is not an instance of it
     * @param date
     *
     * @returns {any}
     */
    public convertDateToMomentObject(date: any): any {
        return moment.isMoment(date) ? date : moment(date);
    }

    /**
     * Gets the difference between two dates
     *
     * @param dateA
     * @param dateB
     * @param unit
     * @returns {number}
     */
    public getDateDiff(dateA: any, dateB: string, unit: any): number {
        dateA = this.convertDateToMomentObject(dateA);

        return dateA.diff(dateB, unit || Constants.DATE_UNIT_DAYS);
    }
}
